import useAxiosInterceptor from 'src/services/interceptor';
import { laborHoursApiConstant } from '../constants';
class LaborHoursService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getLaborHoursList = (payload: any) => {
    return this.axiosInstance.get(`${laborHoursApiConstant.getLaborHours}`, {
      params: payload,
    });
  };
  getLaborCodesList = () => {
    return this.axiosInstance.get(`${laborHoursApiConstant.labourManagement}/labor-codes`);
  };

  addLaborHour = (payload: any) => {
    const { param, ...restPayload } = payload;
    return this.axiosInstance.post(`${laborHoursApiConstant.addLaborHrs}`, restPayload, {
      params: param,
    });
  };

  editLaborHour = (payload: any) => {
    const { param, ...restPayload } = payload;
    return this.axiosInstance.put(`${laborHoursApiConstant.editLaborHours}`, restPayload, {
      params: param,
    });
  };
  getLocationType = () => {
    return this.axiosInstance.get(`${laborHoursApiConstant.locationType}`);
  };
  deleteLaborHour = (payload: any) => {
    return this.axiosInstance.delete(`${laborHoursApiConstant.deleteLabor}/${payload}`);
  };
}

const laborHoursService = new LaborHoursService();

Object.freeze(laborHoursService);

export default laborHoursService;
